<template>
     <BaseContainer class="dnnCloud-UrlsLBT-box" :loading="listLoading" :isHasPageFt="!listLoading">
        <template v-slot:hd>
            <el-col :span="24" class="toolbar">
              <el-form>
                <el-form-item>
                  <el-button type="primary" size="medium" @click="handleAdd" class="adds">新增</el-button>
                </el-form-item>
              </el-form>
            </el-col>
        </template>

        <template v-slot:main>
           <el-table  :data="imgList" highlight-current-row  style="width: 100%;" >
              <el-table-column type="index"  prop="index" label="序号" width="80">
                <template slot-scope="scope">
                    <span>{{(pageNumber - 1) * pageSize + scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="lbtfileName" label="名称" min-width="140" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="lbtpic2" header-align="center" align="center" min-width="200" label="图片">
                <template slot-scope="scope">
                  <img slot="reference" :src="scope.row.lbtpic2" :alt="scope.row.lbtpic2" class="tpimg">
                </template>
              </el-table-column>
              <el-table-column prop="px" label="排序" min-width="140" >
                <template slot-scope="{row,$index}">
                    <el-input type="tel" style="width:100px;" onkeypress='return( /[\d]/.test(String.fromCharCode(event.keyCode) ) )' 
                      @keyup.enter.native="loseFcous($index, row)" @blur="loseFcous($index, row)" v-if="imgList[$index]" v-model="row.px" >
                    </el-input>
                    <span v-if="!imgList[$index]">{{row.px}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="lbtlink" label="超链接" min-width="250" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.lbtlink || '-' }}
                  </template>
              </el-table-column>

              <el-table-column label="操作" min-width="220" style="text-algin:center">
                <template slot-scope="scope">
                  <span class="operate">
                    <el-tooltip effect="dark" content="编辑" placement="top" >
                      <span class="dnnfont iconEdit"  @click="handleEdit(scope.$index, scope.row)"></span>
                    </el-tooltip>

                    <el-tooltip effect="dark" content="删除" placement="top" v-if="!scope.row.delShow">
                        <span class="dnnfont icondelete"  @click="handledel(scope.$index, scope.row)"></span>
                    </el-tooltip>
                 </span>

                  <!-- <el-button type="primary"  plain size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                  <el-button type="danger"  plain size="small" @click="handledel(scope.$index, scope.row)">删除</el-button> -->
                </template>
              </el-table-column>
            </el-table>

            <!--新增img界面-->
            <el-dialog class="model-edit" title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
              <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm">
                <el-row>
                  <el-col :span="22"> 
                    <el-form-item label="图片" >
                      <el-upload 
                        ref="upload"
                        :auto-upload="false"
                        :on-change="imgPreview"
                        class="avatar-uploader"
                        :action="upload.postURL"
                        :show-file-list="false" >
                        <!-- :on-success="uploadSuccess"
                        :http-request='submitUpload' -->
                        <img v-if="imageUrl" :src="imageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="名称" prop="lbtfileName">
                      <el-input  v-model="addForm.lbtfileName" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="超链接" prop="lbtlink">
                      <el-input  v-model="addForm.lbtlink" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="排序" prop="px">
                      <el-input  v-model="addForm.px" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button @click.native="addFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="addImgSubmit" :loading="addImgLoading">提交</el-button>
              </div>
            </el-dialog>

            <!--编辑img界面-->
            <el-dialog class="model-edit" title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
              <el-form :model="addForm" label-width="80px" :rules="editFormRules"  ref="addForm">
                <el-row>
                  <el-col :span="22"> 
                    <el-form-item label="图片" >
                      <el-upload
                        ref="upload"
                        :auto-upload="false"
                        :on-change="imgPreview"
                        class="avatar-uploader"
                        :action="upload.postURL"
                        :show-file-list="false" >
                        <img v-if="editImageUrl" :src="editImageUrl" class="avatar">
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="名称" prop="lbtfileName">
                      <el-input  v-model="editForm.lbtfileName" placeholder="请输入" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="超链接" prop="lbtlink">
                      <el-input  v-model="editForm.lbtlink" placeholder="请输入" ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="22"> 
                    <el-form-item label="排序" prop="px">
                      <el-input  v-model="editForm.px" placeholder="请输入"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div slot="footer" class="dialog-footer" style="text-align:center">
                <el-button @click.native="editFormVisible = false">取消</el-button>
                <el-button type="primary" @click.native="editImgSubmit" :loading="editImgLoading">提交</el-button>
              </div>
            </el-dialog>
        </template>

        <template v-slot:ft>
          <!--工具条-->
          <el-col :span="24" class="toolbar">
            <el-pagination 
              layout="sizes, prev, pager, next"
              :page-sizes="[10, 20, 30, 50,100]"
              :current-page="pageNumber" 
              @current-change="handleCurrentChange" 
              @size-change="handleSizeChange"
              :page-size="pageSize"
              :total="total" 
              style="float:right;">
            </el-pagination>
          </el-col>
        </template>
      </BaseContainer>
</template>
<script>
import axios from 'axios'
import { API__code, API_Urls,API_Common,imgURLs} from '../../../api/index.js'
import BaseContainer from '@/components/BaseContainer'
import fitTableHeight from '@/mixins/fitTableHeight.js'
export default {
  mixins: [fitTableHeight],
  inject:['reload'],
  data(){
    return{
      listLoading:false,
      id:'',
      checkCode:'',
      token:'',
      pageSize: 20,
      total:1,
      pageNumber:1,
      editImgLoading:false,
      editFormVisible:false,
      editForm:{},
      editImageUrl:'',
      editFormRules:{
        px: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
      },
      addFormVisible:false,
      addImgLoading:false,
      lbpic:'',
      lbsltUrl:'',
      imageUrl:'',
      addForm:{},
      addFormRules:{
        px: [
          { required: true, message: '请输入排序', trigger: 'blur' }
        ],
      },
      upload: {
          fileList: this.fileList,
          picIds: [],
          postURL: API_Common.upload(),   //post地址
          dialogImageUrl: '',  // 文件地址
          dialogVisible: false,    // 上传文件loading
          data: {
            mode: 'save',    
            token:this.token,
            checkCode:this.checkCode, 
            type:1,         
          }
      },
      rowPX:'',
      imgList:[],
    }
  },

  components: {
    BaseContainer
  },

  methods:{
    loseFcous(index,row){
      //如果为空，则返回之前的PX数字，
      //如果数字没有改变，则不走更新接口，
      let para = {
        token: this.token,
        checkCode: this.checkCode,
        id:row.id,
      };
      API_Common.getLBTDetail(para)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          if(res.data.data.px){
            this.rowPX = res.data.data.px;
            if(!row.px || row.px == this.rowPX){
              return row.px = this.rowPX;
            }else{
              this.editPx(row.id,row.px);
            }
          }
        }
      })
    },
    editPx:function(id,px){
      let param = {
        token: this.token,
        checkCode: this.checkCode,
        id:id,
        mode:'',
        px:px,
      }
      API_Common.setLBlist(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.getlbtList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
      }).catch((err) =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    imgPreview (file, fileList) {
      let fileName = file.name;
      let regex = /(.jpg|.jpeg|.gif|.png|.bmp)$/;
      if (regex.test(fileName.toLowerCase())) {
        this.beformAddImg = file;
        // this.imageUrl = file.url;
        // this.editImageUrl = file.url;
         this.imageUrl = URL.createObjectURL(file.raw);
         this.editImageUrl = URL.createObjectURL(file.raw);
      } else {
        this.$message.error('请选择图片文件');
      }
    },
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getlbtList();
    },
    handleSizeChange(val) {
			this.pageSize = val;
			this.getlbtList();
		},
    //新增
    handleAdd:function(){
      this.addFormVisible = true;
      this.addForm = {};
      this.beformAddImg = '';
      this.lbpic = '';
      this.lbsltUrl = '';
      this.imageUrl = '';
    },
    //删除
    handledel:function(index, row){
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning'
      }).then(() => {
        let param = {
          token:this.token,
          checkCode:this.checkCode,
          id:row.id,
          picid:row.picid,
        }
        API_Common.delLBlist(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '删除成功',
              type: 'success'
            });
            this.getlbtList();
          }else{
            this.$message.error(res.data.message);
            if(res.data.code == 403){
              this.$router.push({path: 'loginAdmin'});
            }
          }
        }).catch((err) =>{
          this.$message.error('数据丢失，试试重新登陆！');
        })
      })
    },
    //编辑
    handleEdit:function(index, row){
      this.editFormVisible = true;
      this.editImageUrl  = row.lbtpic2;
      this.editImgId = row.picid;
      this.beformAddImg = '';
      this.editForm = Object.assign({}, row);
    },

    //提交轮播图
    addImgSubmit:function(){
      let var_this = this;
      if(!this.beformAddImg){
        this.$message.error("请上传图片!");
        return;
      }
      if(!this.addForm.px){
        this.$message.error("请输入排序号!");
        return;
      }
      let formData = new FormData;
      formData.append('pic', this.beformAddImg.raw);
      formData.append('token', this.token);
      formData.append('checkCode', this.checkCode);
      formData.append('mode', 'save');
      let config = {
          'Content-Type': 'multipart/form-data'
      }
      this.addImgLoading = true;
      axios.post(this.upload.postURL, formData, config)
        .then(function(res) {
            if (res.data.code == API__code.SUCCESS) {
              var_this.addSave(res.data.data);
              var_this.$refs.upload.clearFiles();
            }else{
              var_this.$message.error(res.data.message);
              if(res.data.code == 403){
                var_this.$router.push({path: 'loginAdmin'});
              }
              return;
            }
        })
        .catch(function(error) {
            console.log(error);
            return;
        })
    },
    addSave:function(val){
      // var newlbtPath = val.projectPath + val.pic;
      // var newlbtsltUrl = val.projectPath + val.sltUrl;
      var newId = val.id;
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        lbtlink:this.addForm.lbtlink,
        px:this.addForm.px,
        mode:'save',
        lbtpic : val.pic,
        lbtsltUrl:val.sltUrl,
        lbtfileName:this.addForm.lbtfileName,
        picid:newId,
        type:1,
      }
      API_Common.setLBlist(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '保存成功',
            type: 'success'
          });
          this.addFormVisible = false;
          this.getlbtList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.addImgLoading = false;
      }).catch((err) =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.addImgLoading = false;
      })
    },
    editImgSubmit:function(){
      if(!this.editImageUrl && !this.beformAddImg){
        this.$message.error("请上传图片!");
        return;
      }
      if(!this.editForm.px){
        this.$message.error("请输入排序号!");
        return;
      }
      if(this.beformAddImg){
        let var_this = this;
        let formData = new FormData;
        formData.append('pic', this.beformAddImg.raw);
        formData.append('token', this.token);
        formData.append('checkCode', this.checkCode);
        formData.append('oldpicid', this.editImgId);
        formData.append('mode', 'save');
        let config = {
            'Content-Type': 'multipart/form-data'
        }
        axios.post(this.upload.postURL, formData, config)
          .then(function(res) {
            if (res.data.code == API__code.SUCCESS) {
              var_this.editSave(res.data.data);
              var_this.$refs.upload.clearFiles();
            }else{
              var_this.$message.error(res.data.message);
              if(res.data.code == 403){
                var_this.$router.push({path: 'loginAdmin'});
              }
              return;
            }
        })
        .catch(function(error) {
            console.log(error);
            return;
        })
      }else{
        this.editSave();
      }
    },
    editSave:function(val){
      let param;
      if(val){
        this.editForm.lbtpic = val.pic;
        this.editForm.lbtsltUrl = val.sltUrl;
        this.editForm.picid = val.id;
        param ={
          token:this.token,
          checkCode:this.checkCode,
          id:this.editForm.id,
          lbtlink:this.editForm.lbtlink,
          px:this.editForm.px,
          mode:'',
          lbtpic : this.editForm.lbtpic,
          lbtsltUrl:this.editForm.lbtsltUrl,
          lbtfileName:this.editForm.lbtfileName,
          picid:this.editForm.picid,
          type:1,
        }
      }else{
        param ={
          token:this.token,
          checkCode:this.checkCode,
          id:this.editForm.id,
          lbtlink:this.editForm.lbtlink,
          lbtfileName:this.editForm.lbtfileName,
          px:this.editForm.px,
          mode:'',
          type:1,
        }
      }
      this.editImgLoading = true;
      API_Common.setLBlist(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.$message({
            message: '修改成功',
            type: 'success'
          });
          this.editFormVisible = false;
          this.getlbtList();
        }else{
          this.$message.error(res.data.message);
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
        }
        this.editImgLoading = false;
      }).catch((err) =>{
        this.$message.error('数据丢失，试试重新登陆！');
        this.editImgLoading = false;
      })
    },
    getlbtList:function(){
      let param = {
        token:this.token,
        checkCode:this.checkCode,
        listType:'page',
        pageNumber:this.pageNumber,
        pageSize:this.pageSize,
        type:0,
      }
      API_Common.getLBlist(param)
      .then((res) =>{
        if(res.data.code == API__code.SUCCESS){
          this.total = res.data.data.totalRow;
          for(var i=0;i<res.data.data.list.length;i++){
            if(res.data.data.list[i].lbtpic){
              // res.data.data.list[i].lbtpic2 = imgURLs + res.data.data.list[i].lbtpic;
              res.data.data.list[i].lbtpic2 =  res.data.data.list[i].lbtpic;
            }
          }
          this.imgList = res.data.data.list;
        }else{
          if(res.data.code == 403){
            this.$router.push({path: 'loginAdmin'});
          }
          this.$message.error(res.data.message);
        }
      }).catch(err =>{
        this.$message.error('数据丢失，试试重新登陆！');
      })
    },
    //读取cookie
    getCookie: function() {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split('='); //再次切割
          //判断查找相对应的值
          if (arr2[0] == 'dnnyptadmin_token') {
              this.token = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == 'dnnyptadmin_checkCode') {
              this.checkCode = arr2[1];
          } else if (arr2[0] == 'dnnyptadmin_id') {
              this.id = arr2[1];
          }
        }
      }
    },
  },
  created(){
    this.getCookie();
  },
  mounted(){
    this.getlbtList();
  },

}
</script>
<style lang="scss">
.dnnCloud-UrlsLBT-box {
  .base-container-bd {
    .content-hd {
      .el-form-item {
        margin-bottom: 0;
      }
    }
  }
}

</style>
<style>
.el-tabs__nav-scroll {
    padding:0;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px;
  text-align: center;
}
.avatar {
  width: 150px;
  height: 150px;
  display: block;
}

</style>




// WEBPACK FOOTER //
// UrlsLBT.vue?5b073f6a